





import { Component, Prop, Vue } from 'vue-property-decorator';
import ProsemirrorViewerText from '@/editor/editor-block-view/components/ProsemirrorViewerText.vue';
import { fallbackTextContent } from '@/editor/editor-block/constants';
import { IText, ITextContentDoc, IMergeValues, IField } from '@/editor/types';
@Component({
  components: {
    ProsemirrorViewerText,
  },
})
export default class EditorNodeText extends Vue {
  @Prop() node: IText;
  @Prop() mergeValues: IMergeValues;

  get fields(): IField[] {
    return this.node?.fields || [];
  }

  get jsonContent(): ITextContentDoc {
    const textContent: string = this.node?.content;
    return JSON.parse(textContent || fallbackTextContent);
  }
}
